import "./PhoneAuth.css";
import "../components/fonts.css";
import { getAuth, RecaptchaVerifier } from "firebase/auth";
import logo from "../assets/logo.png";
import Submit_button from "../components/submit_button.js";
import { useState, useEffect } from "react";
import { auth } from "../services/firebase.config.js";
import { recaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { toast, Toast, Toaster } from "react-hot-toast";
import Header from "../components/header.js";
import { useNavigate } from "react-router-dom";

function PhoneAuth() {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [showOtpPage, setshowOtpPage] = useState(false);
  const [code, setCode] = useState("");
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = (event) => {
    if (phoneNumber.length === 0) {
      toast.error("Please enter your phone number !");
    } else {
      event.preventDefault();
      onSignup();
    }
  };

  // we update the phoneNumber variable when we type something in the input
  const handleNumberInputChange = (event) => {
    setPhoneNumber(event.target.value);
  };

  // we update the code variable when we type something in the input
  const handleCodeInputChange = (event) => {
    setCode(event.target.value);
  };

  //capatcha verify
  const onCapatchaVerify = () => {
    if (!window.recaptchaVerifier) {
      window.recaptchaVerifier = new RecaptchaVerifier(
        "recaptcha-container",
        {
          size: "invisible",
          callback: (response) => {
            onSignup();
          },
          "expired-callback": () => {
            // Response expired. Ask user to solve reCAPTCHA again.
            // ...
            toast.error("capatcha failed!");
          },
        },
        auth
      );
    }
  };

  function onSignup() {
    onCapatchaVerify();

    const appVerifier = window.recaptchaVerifier;

    const auth = getAuth();
    signInWithPhoneNumber(auth, phoneNumber, appVerifier)
      .then((confirmationResult) => {
        // SMS sent. Prompt user to type the code from the message, then sign the
        // user in with confirmationResult.confirm(code).
        window.confirmationResult = confirmationResult;
        // show the otp page and hide the phone number page
        setshowOtpPage(true);
        toast.success("Otp sended successfully!");
      })
      .catch((error) => {
        // Error; SMS not sent
        console.log(error.message);
      });
  }

  // comparing the otp with the entered text
  const onOtpVerify = () => {
    if (code.length === 0) {
      toast.error("Please enter the code we sent to your number !");
    } else {
      window.confirmationResult
        .confirm(code)
        .then((result) => {
          console.log(result);
          setUser(result.user);
          toast.success("connected successfully!");
          // after 5 seconds, we decconect the user
          navigate("/top_outfits");
        })
        .catch((error) => {
          console.log(error);
          toast.error(error);
        });
    }
  };

  return (
    <>
      <Header user="influencer" />
      <div className="PhoneNumber">
        <Toaster toastOptions={{ duration: 2000 }} />
        <div id="recaptcha-container"></div>
        {user ? (
          <h3 className="connected_text">Connected</h3>
        ) : (
          <>
            <img className="Happer_image" src={logo} alt="Happer LOGO" />
            <h1 style={{ fontSize: "48px", marginTop: "0px" }}>Happer</h1>
            {!showOtpPage ? (
              <>
                <p className="hint">insérez votre numéro de téléphone</p>
                <input
                  type="tel"
                  name="phone-number"
                  value={phoneNumber}
                  onChange={handleNumberInputChange}
                  placeholder="123-456-7890"
                  required
                />
                <Submit_button title="Valider" onClick={handleSubmit} />
              </>
            ) : (
              <>
                <p className="hint">insérez votre code de vérification</p>
                <input
                  type="tel"
                  value={code}
                  onChange={handleCodeInputChange}
                  placeholder="Code de connexion..."
                  required
                />
                <Submit_button title="Valider" onClick={onOtpVerify} />
              </>
            )}
          </>
        )}
      </div>
      <div style={{ marginBottom: "300px" }}></div>
    </>
  );
}

export default PhoneAuth;
